var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "job-detail job-detail--social-media-specialista" },
      [
        _c("div", { staticClass: "job-detail__heading" }, [
          _c("h2", [
            _vm._v(
              "\n            Máš vášeň pro sociální sítě, nápady a chceš nahlédnout pod pokličku reklamní agentury v centru Brna? \n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "job-detail__subheading" }, [
          _c("div", { staticClass: "job-detail__subheading__spacer-block" }, [
            _c("div", {
              staticClass: "job-detail__subheading__spacer-block__line"
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "job-detail__subheading__text-block" }, [
            _c("p", [
              _vm._v(
                "Do týmu hledáme Social Media Specialist(k)u, který/která nám pomůže pečovat o online prezentaci našich klientů. Pokud se nebojíš samostatné práce a máš chuť se učit a přicházet s vlastními nápady, přidej se k nám!"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "job-detail__text" }, [
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("h3", [_vm._v("Co tě u nás čeká?")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v("Aktivně se podílet na tvorbě obsahové strategie")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Spolupracovat na tvorbě scénářů, storyboardů a nápadů")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Pomáhat s produkcí video a foto obsahu")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Podpora při vytváření příspěvků, stříhání a úprava video obsahu (reels, stories), práce s grafickými nástroji"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Přicházet s vlastními kreativními nápady na obsah a kampaně, sledovat nejnovější trendy a navrhovat inovativní přístupy"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Pomáhat se správou a rozvojem profilů klientů na různých sociálních platformách"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Analyzovat výsledky a hledat cesty, jak zlepšit výkonnost klientů na sociálních sítích."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Prostor pro vlastní iniciativu a samostatné řešení úkolů")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Učit se a růst v dynamickém prostředí")])
          ]),
          _vm._v(" "),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("h3", [_vm._v("Co oceníme u tebe?")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Baví tě sociální sítě a rozumíš jim (alespoň základní znalost)."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Chuť učit se novým věcem a aktivní přístup k práci.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Kreativitu a schopnost přicházet s novými nápady.")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Komunikativnost a zodpovědnost.")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Možnost docházet do naší kanceláře v centru Brna.")
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("h3", [_vm._v("Co ti nabízíme?")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Flexibilní pracovní dobu, kterou si můžeš přizpůsobit studiu či dalším povinnostem."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Možnost získat cenné praktické zkušenosti v oblasti online marketingu."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Práci na zajímavých projektech pro různorodé klienty.")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Přátelský tým a otevřenou komunikaci.")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Práci na dohodu, zkrácený úvazek nebo spolupráci na IČO.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Kanceláře v centru Brna a další benefity po dohodě.")
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }